<!--
 * @Author: 曹捷
 * @Date: 2021-10-25 11:07:15
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-07-01 16:17:51
 * @Description: 左侧主菜单
-->
<template>
  <div class="ybt-logo t-c flex-c-c  " :style="{'height':config.header.height+'px'}">
    <obitEnv>
      <template #zs>
        <img class="logo" src="@/assets/zs/images/logo.svg" style="padding:8px;" alt="">
      </template>
      <template #xj>
        <img class="logo" src="@/assets/images/login/xj1.png" style="padding:8px;" alt="">
      </template>
      <img class="logo" src="@/assets/images/login/yhlLogo.svg" alt="">
    </obitEnv>
  </div>
  <a-tabs class="main-menu" tab-position="right" :style="{ width: '100%' }" v-model:activeKey="activeKey" @change="tabChange">
    <a-tab-pane v-for="item in routerList" :key="item.key">
      <template #tab>
        <span class="flex-c-c">
          <i class="iconfont " :class="item.icon"></i>
          {{item.name}}
        </span>
      </template>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import { useStore } from 'vuex'
import { reactive, toRefs, computed } from '@vue/reactivity'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, watch } from 'vue'
import MenuHook from './../../hook/menu'
export default {
  setup (props, context) {
    let _data = reactive({
      activeKey: 'home',
      routerList: [
        { name: '首页', key: 'home', path: '/main/home', icon: 'icon-saas_Home' },
        { name: '控制台', key: 'center', path: '', icon: 'icon-saas_kongzhi' },
        { name: '设置', key: 'set', path: '/main/set/myserver', icon: 'icon-saas_shezhi' },
      ]
    })
    let store = useStore()
    let router = useRouter()
    let route = useRoute()
    let menuHook = MenuHook()
    let config = store.state.settings
    let method = {
      sysyActiveKey () {
        let path = route.path
        if (path === '/main/home') {
          _data.activeKey = 'home'
        } else if (path.indexOf('/main/set') !== -1) {
          _data.activeKey = 'set'
        } else {
          _data.activeKey = 'center'
        }
      }
    }
    let _methods = {
      tabChange (activeKey) {
        let item = _data.routerList.find(el => el.key === activeKey)
        if (item.path) {
          router.push({ path: item.path })
        } else {
          menuHook.toCenterController(store)
        }
      }
    }
    let _computed = {
      config: computed(() => store.state.settings)
    }
    watch(() => route.path, () => {
      method.sysyActiveKey()
    })
    onMounted(() => {
      method.sysyActiveKey()
    })
    return {
      ...toRefs(_data),
      ..._computed,
      ..._methods
    }
  }
}
</script>

<style lang="less">
.ybt-logo {
  border-bottom: 1px solid #404040;
  .iconfont {
    font-size: 30px !important;
    color: @menuTSC;
  }
  .logo {
    width: 100%;
  }
}
.main-menu.ant-tabs {
  border-bottom: 1px solid #404040;
  .iconfont {
    font-size: 18px;
  }
  .ant-tabs-tab-active {
    color: @menuTSC;
  }
  .ant-tabs-tab:hover {
    color: @menuTSC;
  }
  .ant-tabs-ink-bar {
    background: @menuTSC;
  }
  .ant-tabs-right-bar {
    width: 100%;
    margin-left: 1px;
    border-left: 0;
    padding-left: 2px;
    .ant-tabs-tab {
      text-align: center !important;
      padding: 8px 0 !important;
    }
    .ant-tabs-tab-active {
      background: #22395c;
    }
  }
}
</style>